import createVueApp from '@/common/createApp'
import { routerStyxie } from '@/router/styxieBridge'

// The splash (feature disabled) stays a plain page: no sidebar and nothing to
// route between. The projects index boots the router shell; its props come
// from the global store (see router/routes/mlap.js).
const { show: bootRouter } = routerStyxie({ actions: ['show']})

Styxie.Initializers.Mlap = {
  show: async(props) => {
    if (!props.splash) return bootRouter(props)

    const { default: MlapSplash } = await import('@/vue_widgets/mlap/splash/index.vue')
    return createVueApp(MlapSplash, { props })
  }
}
